import axios, { AxiosResponse } from "axios";
import { StudentCertificate } from "./MagInstituteModels";


export class StudentCourseService {

    async getCertificateDetails(certificateNumber: string): Promise<AxiosResponse<StudentCertificate>> {
        
        var url = process.env.REACT_APP_API_URL + "/CourseCertificate/CertificateDetails?certificateNumber=" + certificateNumber;
       
        //This has no authentication. Anonymous. So access directly without the TOKEN
        var instance = axios.create({
            headers: { "Content-Type": "application/json"}         
        });
        

        var response = await instance.get<StudentCertificate>(url);

        // return response;     
        return response;  
    }

}